import { Stack } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { pageTabHeaderTypographyProps } from "@/App/Layouts/PageBody/PageTabHeader";
import ContractView from "@/common/components/Entity/Contract/View/ContractView";
import { ViewVariant } from "@/common/ts/layout";
import { DamageCostEvaluationDto } from "@/core/api/generated/v1";

interface Props {
  damageCostEvaluation: DamageCostEvaluationDto;
}

export default function ContractTabContent({ damageCostEvaluation }: Props) {
  return (
    <PageTabContent>
      <Stack direction='column' spacing={2}>
        <ContractView
          contractId={damageCostEvaluation.contract?.id}
          contract={undefined}
          displayProps={{
            breadcrumbs: false,
            header: false,
            actions: true,
            viewVariant: ViewVariant.Tab,
          }}
          headerProps={{
            withLink: true,
            typographyProps: pageTabHeaderTypographyProps.title,
          }}
          onDelete={null}
        />
      </Stack>
    </PageTabContent>
  );
}
